class Ingredients extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const swiperPackItem = new Swiper(this.querySelector('.swiper-ingredients '), {
            slidesPerView: 2,
            spaceBetween: 10,
            pagination: {
                el: this.querySelector('.swiper-pagination'),
                clickable: true,
            },
            navigation: {
                nextEl: this.querySelector(' .swiper-next'),
                prevEl: this.querySelector(' .swiper-prev'),
            },
            breakpoints: {
                640: {
                    slidesPerView: 3,
                    spaceBetween: 16,
                },
                768: {
                    slidesPerView: 4,
                    spaceBetween: 16,
                },
                1024: {
                    slidesPerView: 5,
                    spaceBetween: 16,
                },
            }

        });
    }

}

customElements.define('ingre-dients', Ingredients);